import React from 'react';

import './LegendTooltipContent.theme.scss';

function LegendTooltipContent() {
  return (
    <div className="legend-tooltip">
      <div className="legend-tooltip__title">
        <h4 className="legend-tooltip__title-text">Legend</h4>
        <p className="legend-tooltip__description">Colors and Details</p>
      </div>
      <div className="legend-tooltip__routes">
        <div className="legend-tooltip__child">
          <div className="legend-tooltip__route-icon legend-tooltip__route-icon--published" />
          <p className="legend-tooltip__description">Published route</p>
        </div>
        <div className="legend-tooltip__child">
          <div className="legend-tooltip__route-icon legend-tooltip__route-icon--predicted" />
          <p className="legend-tooltip__description">Predicted route</p>
        </div>
        <div className="legend-tooltip__child">
          <div className="legend-tooltip__route-icon legend-tooltip__route-icon--customized" />
          <p className="legend-tooltip__description">Customized route</p>
        </div>
        <div className="legend-tooltip__child">
          <div className="legend-tooltip__route-icon legend-tooltip__route-icon--commercial" />
          <p className="legend-tooltip__description">Commercially available compounds</p>
        </div>
      </div>
    </div>
  );
}

export default LegendTooltipContent;
